import axios from 'axios';
import { REACT_APP_API } from '../../config';
import {toast} from 'react-toastify';

export async function updateGroup(group_id, groupUpdate, opts = {}) {
    const { skipSuccessToast = false } = opts
    try {
        const res = await axios.put(`${REACT_APP_API}/groups/${group_id}`, groupUpdate)
        if (!skipSuccessToast) {
            toast.success('Guardaste los cambios correctamente.')
        }
        return res
    } catch (error) {
        toast.error('Algo salió mal, intenta de nuevo en unos minutos.', { autoClose: false })
        console.log(error)
    }
}